import { render, staticRenderFns } from "./CompanyFeaturesCard.vue?vue&type=template&id=988f536c"
import script from "./CompanyFeaturesCard.vue?vue&type=script&lang=js"
export * from "./CompanyFeaturesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports